module.exports = __webpack_public_path__ + "static/img/Miaoli_02.bd67bf8a.jpg";